import { render, staticRenderFns } from "./statsByDriver.vue?vue&type=template&id=52a4d7e2&"
import script from "./statsByDriver.vue?vue&type=script&lang=js&"
export * from "./statsByDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports